// Colour-match (qa-runs#362): with the DM's setting on (remembered with their layout, `PanelPrefs.colourMatch`), the
// one token selected that carries a marker colour lends it to the Properties panel's header and border, and to a
// matching swatch on its entries in the scene's object list and the turn order — so the panel and the token it shows are
// visibly paired. Nothing is sent: it is this person's look, read from the board they are shown.
import type { Marker } from '@dragons-table/vtt-shared';
import { useTableState } from '../table/TableState';
import { usePanelPrefs } from './panelPrefs';
import { useLook } from './useLook';

export interface Matched { id: string; colour: string }

/** The token the panel is paired with and its colour, or null: the setting off, not exactly one selected, or no marker. */
export function useColourMatch(selected: ReadonlySet<string>): Matched | null {
  const prefs = usePanelPrefs();
  const { store } = useTableState();
  const look = useLook();
  if (!prefs.colourMatch || selected.size !== 1) return null;
  const id = [...selected][0]!;
  const o = store.state.objects[id] as { kind: string; marker?: Marker | null } | undefined;
  if (!o || o.kind !== 'token' || !o.marker) return null;
  return { id, colour: look.marker(o.marker) };
}

/** The swatch beside a matched entry's name. */
export function MatchSwatch({ colour, of }: { colour: string; of: string }) {
  return <span data-testid="match-swatch" role="img" aria-label={`${of}'s colour`} className="inline-block h-3 w-3 shrink-0 rounded-full border border-stone-900" style={{ backgroundColor: colour }} />;
}
